import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

console.log("📍 supabaseClient.js - 1 - URL existe:", !!supabaseUrl);
console.log("📍 supabaseClient.js - 2 - Key existe:", !!supabaseAnonKey);

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("❌ Variables d'environnement Supabase manquantes!");
}

console.log("📍 supabaseClient.js - 3 - Création du client");

// Créer une seule instance de Supabase pour toute l'application
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storageKey: 'supabase.auth.token',
    storage: window.localStorage,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

console.log("📍 supabaseClient.js - 4 - Client créé:", !!supabase);

// Liste des buckets requis de façon statique
const REQUIRED_BUCKETS = [
  'signatures',
  'vehicle-photos',
  'interventions-pdf',
  'client-documents'
];

// Fonction simple pour éviter les vérifications répétées
const isVerifiedInCache = () => {
  return localStorage.getItem('bucketsVerified') === 'true';
};

// Fonction pour vérifier les buckets nécessaires
export const verifyRequiredBuckets = async () => {
  // Si déjà vérifié avec succès via le cache
  if (isVerifiedInCache()) {
    console.log("✅ Buckets déjà vérifiés (depuis localStorage)");
    return { success: true, missingBuckets: [] };
  }
  
  try {
    // Au lieu de lister les buckets, essayer d'accéder à chacun individuellement
    const inaccessibleBuckets = [];
    
    for (const bucket of REQUIRED_BUCKETS) {
      try {
        const { data, error } = await supabase.storage.from(bucket).list('', { limit: 1 });
        if (error) {
          console.warn(`⚠️ Problème d'accès au bucket '${bucket}':`, error.message);
          inaccessibleBuckets.push(bucket);
        } else {
          console.log(`✅ Bucket '${bucket}' accessible.`);
        }
      } catch (e) {
        console.error(`❌ Exception lors du test d'accès au bucket '${bucket}':`, e);
        inaccessibleBuckets.push(bucket);
      }
    }
    
    if (inaccessibleBuckets.length > 0) {
      console.warn("⚠️ ATTENTION: Les buckets suivants sont requis mais inaccessibles:", inaccessibleBuckets.join(', '));
      console.warn("Veuillez vérifier que ces buckets existent et que leurs politiques sont correctement configurées.");
      return { success: false, missingBuckets: inaccessibleBuckets };
    }
    
    // Tout est OK, mémoriser pour éviter des vérifications répétées
    localStorage.setItem('bucketsVerified', 'true');
    console.log("✅ Tous les buckets nécessaires sont accessibles.");
    return { success: true, missingBuckets: [] };
  } catch (error) {
    console.error("❌ Erreur lors de la vérification des buckets:", error);
    return { success: false, missingBuckets: REQUIRED_BUCKETS };
  }
};

// Option pour contourner la vérification si nécessaire
export const forceBucketsAvailable = () => {
  localStorage.setItem('bucketsVerified', 'true');
  console.log("✅ Buckets marqués comme vérifiés avec succès (override)");
  return { success: true, missingBuckets: [] };
};

// NE PAS vérifier les buckets au démarrage - c'était le problème
// Les vérifications se font maintenant à la demande dans les composants
console.log("📍 supabaseClient.js - 5 - Export terminé");